// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"82233022","453":"fde5c8a1","732":"aa39ecab"}[chunkId] + ".chunk.js";
};